import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateChainStoreContractStores } from '../../api/chain-store-contract.ts';
import type { UpdateChainStoreContractStoresRequest } from '../../api/requests/chain-store-contract-request.ts';

export default function useUpdateChainStoreContractStores(): UseMutationResult<
  string,
  Error,
  UpdateChainStoreContractStoresRequest
> {
  return useMutation({
    mutationFn: updateChainStoreContractStores,
  });
}
